module.exports = __webpack_public_path__ + "assets/img/6137ea4da39691da33bfb01e4be632a6.png";